import PropTypes from 'prop-types';
import React, {useMemo} from 'react';
import {Field} from 'redux-form';
import {useQuery} from '@apollo/client';

import {FiltersWrapper} from '@appComponents/HOCFiltersWrapper';
import Form from '@appComponents/ReduxFormControls';
import {GetCountryIsoCodesForDropdown} from '@graphql/country/query';
import {GetSportsForDropdown} from '@graphql/sport/query';
import {CountriesFilter} from '@utils/commonFilters/CountriesFilter';
import {SearchFilter} from '@utils/commonFilters/SearchFilter';
import {LMT} from '@constants/staticDropdowns';
import {SportsFilter} from '@utils/commonFilters/SportsFilter';
import {StatusFilter} from '@utils/commonFilters/StatusFilter';

import {showErrorNotificationMessage} from '../utils/lcrChannels';

const LcrChannelFilters = ({
    restoreFilterValues,
    restoreFilterBooleanValues,
    filters,
    loading: loadingFilters,
}) => {

    const {
        data: {
            countries,
        } = {},
        error: errorFetchingCountriesData,
        loading: isCountriesLoading = true,
    } = useQuery(GetCountryIsoCodesForDropdown);

    const {
        data: {
            sports,
        } = {},
        error: errorFetchingSportsData,
        loading: isSportsDataLoading = true,
    } = useQuery(GetSportsForDropdown);

    useMemo(() => {
        errorFetchingCountriesData && errorFetchingSportsData && showErrorNotificationMessage();
    }, [errorFetchingCountriesData, errorFetchingSportsData]);

    const loading = (isCountriesLoading || isSportsDataLoading) || loadingFilters;

    return (
        <div className='content__filters'>
            <SearchFilter
                loading={loading}
                filters={filters.LcrChannel}
                restoreFilterValues={restoreFilterValues}
            />
            <Field
                component={Form.ReduxSelect}
                disabled={loading}
                loading={loading}
                name='has_lmt_support'
                placeholder='LMT'
                options={LMT}
                setValue={restoreFilterBooleanValues(filters.LcrChannel, 'has_lmt_support', null, 'LMT filters value is not valid')}
                selection
            />
            <CountriesFilter
                countries={countries}
                loading={loading}
                filters={filters.LcrChannel}
                restoreFilterValues={restoreFilterValues}
            />
            <SportsFilter
                sports={sports}
                loading={loading}
                filters={filters.LcrChannel}
                restoreFilterValues={restoreFilterValues}
            />
            <StatusFilter
                loading={loading}
                filters={filters.LcrChannel}
                restoreFilterValues={restoreFilterBooleanValues}
                statusType='IS_ENABLED'
                fieldName='status'
                defaultValue={1}
                errorMessage='Status filters value is not valid'
            />
        </div>
    );
};

LcrChannelFilters.propTypes = {
    filters: PropTypes.shape({
        LcrChannel: PropTypes.object.isRequired,
    }),
    loading: PropTypes.bool,
    restoreFilterValues: PropTypes.func.isRequired,
    restoreFilterBooleanValues: PropTypes.func.isRequired,
};

export default FiltersWrapper(LcrChannelFilters, {name: 'LcrChannel', initialValues: {status: 1}});
